import types from '../../../mutation-types';

export const setPageFilter = ({ dispatch, filter, page, markEndReached }) => {
  dispatch('conversationPage/setCurrentPage', { filter, page }, { root: true });
  if (markEndReached) {
    dispatch('conversationPage/setEndReached', { filter }, { root: true });
  }
};

export const setContacts = (commit, chatList) => {
  commit(
    `contacts/${types.SET_CONTACTS}`,
    chatList.map(chat => chat.meta.sender)
  );
};

export const isOnMentionsView = ({ route: { name: routeName } }) => {
  const MENTION_ROUTES = [
    'conversation_mentions',
    'conversation_through_mentions',
  ];
  return MENTION_ROUTES.includes(routeName);
};

export const isOnUnattendedView = ({ route: { name: routeName } }) => {
  const UNATTENDED_ROUTES = [
    'conversation_unattended',
    'conversation_through_unattended',
  ];
  return UNATTENDED_ROUTES.includes(routeName);
};

export const isOnFoldersView = ({ route: { name: routeName } }) => {
  const FOLDER_ROUTES = [
    'folder_conversations',
    'conversations_through_folders',
  ];
  return FOLDER_ROUTES.includes(routeName);
};

export const shouldAddContactToList = rootState => {
  const routeName = rootState?.route?.name;
  const routeQuery = rootState?.route?.query || {};
  const routeParams = rootState?.route?.params || {};
  const appliedContactFilters = rootState?.contacts?.appliedFilters || [];
  const isOnContactsListRoute = [
    'contacts_dashboard_index',
    'contacts_dashboard_segments_index',
    'contacts_dashboard_labels_index',
  ].includes(routeName);

  if (!isOnContactsListRoute) {
    return true;
  }

  const hasScopedContactView =
    !!routeQuery.search ||
    routeName === 'contacts_dashboard_segments_index' ||
    routeName === 'contacts_dashboard_labels_index' ||
    !!routeParams.segmentId ||
    !!routeParams.label ||
    !!appliedContactFilters.length;

  return !hasScopedContactView;
};

export const buildConversationList = (
  context,
  requestPayload,
  responseData,
  filterType,
  { replace = false, updateStats = true, updateLoading = true } = {}
) => {
  const { payload: conversationList, meta: metaData } = responseData;
  context.commit(
    replace ? types.REPLACE_FILTERED_CONVERSATIONS : types.SET_ALL_CONVERSATION,
    conversationList
  );
  context.commit(types.SET_FILTERED_CONVERSATIONS_COUNT, metaData?.all_count);
  if (updateStats) {
    context.dispatch('conversationStats/set', metaData);
  }
  context.dispatch(
    'conversationLabels/setBulkConversationLabels',
    conversationList
  );
  if (updateLoading) {
    context.commit(types.CLEAR_LIST_LOADING_STATUS);
  }
  setContacts(context.commit, conversationList);
  setPageFilter({
    dispatch: context.dispatch,
    filter: filterType,
    page: requestPayload.page,
    markEndReached: !conversationList.length,
  });
};
